import styled from '@emotion/styled';
import Typography from '@portalterreno/react-ui-core/Typography';

const StyledTypography = styled(Typography)({
  margin: 0,
  opacity: 0.83
});

export default StyledTypography;
